<style lang="less" scoped>
  @import './styles.less';
</style>

<template>
  <div class="disease-item">
    <div class="title">
      <div>
        <span class="name">{{num ? (num + '、') : ''}}{{data.name}}</span>
        <span class="type">中医病症</span>
      </div>
    </div>
    <div class="details">
      <div class="field">
        <span style="width: 70px;">症&nbsp;&nbsp;&nbsp;&nbsp;状&nbsp;&nbsp;&nbsp;：</span>
        <div class="tags">
          <span v-for="item in items" :key="item">{{item}}</span>
        </div>
      </div>
      <div class="field">
        <span style="width: 70px;">辩证要点：</span>
        <div>{{data.dialecticalPoint}}</div>
      </div>
    </div>
    <div class="btns">
      <div @click="$emit('action', { type: 'details', data })">查看病症解说</div>
      <div @click="$emit('action', { type: 'call', data })">方剂调用(1)</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: { type: Object, default: null },
    num: { type: Number, default: null },
  },
  computed: {
    items () {
      return (this.data ? (this.data.symptom ? this.data.symptom.split(/[,，]/) : []) : []).filter(v => v)
    }
  }
}
</script>
